import React from 'react';
import './Modal.css';

const HowToPlayModal = ({ onClose, gameMode }) => {
  const isConnections = gameMode === 'connections';

  return (
    <div className="modal-overlay">
      <div className="modal-content left">
        <button className="close-button" onClick={onClose}>×</button>

        {isConnections ? (
          <>
            <h2>how to play iconn🧩ct</h2>
            <p>Find groups of four emojis that share a common movie!</p>
            <ul>
              <li>Select four items and tap 'Submit' to check if your guess is correct.</li>
              <li>Find the groups without making more than 4 mistakes!</li>
              <li>Each group is assigned a color, which will be revealed as you solve:</li>
            </ul>
            <div className="difficulty-guide">
              <p><span className="diff-dot yellow">🟨</span> Straightforward</p>
              <p><span className="diff-dot green">🟩</span> Familiar</p>
              <p><span className="diff-dot blue">🟦</span> Challenging</p>
              <p><span className="diff-dot purple">🟪</span> Tricky / Playful</p>
            </div>
            <h2>Examples</h2>
            <ul>
              <li><b>THE MATRIX</b>: 💊, 🕶️, 💻, 🟢</li>
              <li><b>FROZEN</b>: ❄️, ⛄, 👸, 🦌</li>
            </ul>
          </>
        ) : (
          <>
            <h2>how to play mojie classic</h2>
            <p>Solve each emoji based clue to reveal the title of a movie!</p>
            <p>Use the theme of the day to aid your guesses.</p>
            <ul>
              <li>Type your answer and enter it in each box.</li>
              <li>If you are stuck, the 🗓️🎭🎬🌟 buttons below each clue are hints you may reveal (that add a 💡 penalty to your result). </li>
              <li>You are allowed 4 guesses ⚪️ per movie.</li>
              <li>If you answer a movie correctly before your guess attempts are used, you will earn a ✅ in your result.</li>
              <li>You may only view and share your results once all 3 movies have been solved!</li>
            </ul>
            <h2>Clue Examples</h2>
            <ul>
              <li>Theme: “Bon Appétit”, Clue: 👨🏼‍🍳🦱🐀 🍝, Answer: “Ratatouille”</li>
            </ul>
            <p>The movies are ordered by relative level of difficulty:</p>
            <p>Easy 🟩 - Medium 🟦 - Hard 🟪</p>
          </>
        )}

        <p style={{ marginTop: '1.5rem', borderTop: '1px solid #eee', paddingTop: '1rem' }}>
          Good luck, cinephiles! 🍿
        </p>
      </div>
    </div>
  );
};

export default HowToPlayModal;
